export enum ActionType {
  FETCH_USERINFO = "fetch_userinfo",
  FETCH_USERINFO_SUCCESS = "fetch_userinfo_success",
  FETCH_USERINFO_ERROR = "fetch_userinfo_error",
  USERLOGIN = "user_login",
  USERLOGIN_SUCCESS = "user_login_success",
  USERLOGIN_ERROR = "user_login_error",
  SHOW_NAVIGATION = "show-navigation",
  FETCH_GUILD_LIST = "fetch_guild_list",
  FETCH_GUILD_LIST_SUCCESS = "fetch_guild_list_success",
  FETCH_GUILD_LIST_ERROR = "fetch_guild_list_error",
  FETCH_HEALTH_PROTOCOLS = "fetch_health_protocols",
  FETCH_HEALTH_PROTOCOLS_SUCCESS = "fetch_health_protocols_success",
  FETCH_HEALTH_PROTOCOLS_ERROR = "fetch_health_protocols_error",
  FETCH_GUILD_SINGLE = "fetch_guild_single",
  FETCH_GUILD_SINGLE_SUCCESS = "fetch_guild_single_success",
  FETCH_GUILD_SINGLE_ERROR = "fetch_guild_single_error",
  FETCH_PROVINCES = "fetch_provinces",
  FETCH_PROVINCES_SUCCESS = "fetch_provinces_success",
  FETCH_PROVINCES_ERROR = "fetch_provinces_error",
  FETCH_FLIGHT_LIST = "fetch_flight_list",
  FETCH_FLIGHT_LIST_SUCCESS = "fetch_flight_list_success",
  FETCH_FLIGHT_LIST_ERROR = "fetch_flight_list_error",
}
